__turbopack_context__.v({
  "bottomSheet": "e-7R8G_bottomSheet",
  "root": "e-7R8G_root",
});
